import * as ActionTypes from '../action-types'

const loyalty_defaultState = {
    byID: {},
    allIDs: [],
}

export const privilege = (state = loyalty_defaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))    

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.PRIVILEGE_GET_ALL: {

            const privilege = action.privileges

            privilege
            &&
            privilege.length
            &&
            privilege.map(privilege => {

                const { feeid } = privilege

                newState.byID[feeid] = privilege

                if(!newState.allIDs.includes(feeid)) newState.allIDs.push(feeid)

                return null
            })

            return newState;
        }
        default: {
            return state;
        }
    }
}